// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3jxyv","tab":"ProcedureTabs_tab__r-Gns"};